export default {
  'cdn.ops.dashboard.overview.error':
    '概览加载失败，正在重试；已有数据可能已过期',
  'cdn.ops.dashboard.nodes.error': '节点样本加载失败',
  'cdn.ops.dashboard.abnormal.sampleTitle': '异常节点速览（节点列表首页样本）',
  'cdn.ops.dashboard.abnormal.sampleEmpty': '当前样本中暂无异常节点',
  'cdn.https.cert.title': '证书信息',
  'cdn.https.cert.mode': '当前证书方式',
  'cdn.https.cert.auto': '自动申请',
  'cdn.https.cert.manual': '手动填写',
  'cdn.https.cert.httpsDisabled': 'HTTPS 已关闭',
  'cdn.https.cert.savedConfigTip':
    '以下信息来自已保存配置与证书记录，不代表所有边缘节点已完成加载。',
  'cdn.https.cert.autoTip':
    '证书由系统按域名自动申请和续期。新域名证书就绪前不执行强制 HTTPS 跳转，直接访问 HTTPS 仍可能失败。',
  'cdn.https.cert.refresh': '刷新',
  'cdn.https.cert.loadFailed': '证书信息加载失败，请刷新重试',
  'cdn.https.cert.domain': '域名',
  'cdn.https.cert.domains': '证书包含域名',
  'cdn.https.cert.status': '证书状态',
  'cdn.https.cert.issuer': '颁发机构',
  'cdn.https.cert.notBefore': '生效时间',
  'cdn.https.cert.notAfter': '到期时间',
  'cdn.https.cert.remaining': '剩余有效期',
  'cdn.https.cert.days': '{days} 天',
  'cdn.https.cert.lessThanDay': '不足 1 天',
  'cdn.https.cert.attempt': '最近申请／续期情况',
  'cdn.https.cert.reason': '说明',
  'cdn.https.cert.operation': '操作',
  'cdn.https.cert.details': '查看详情',
  'cdn.https.cert.keyMatches': '证书与私钥',
  'cdn.https.cert.matched': '匹配',
  'cdn.https.cert.mismatched': '不匹配或私钥无效',
  'cdn.https.cert.renewal': '更新方式',
  'cdn.https.cert.autoRenewal': '自动续期',
  'cdn.https.cert.manualRenewal': '手动更新',
  'cdn.https.cert.coverage': '证书覆盖情况',
  'cdn.https.cert.coverageTitle': '站点域名覆盖情况',
  'cdn.https.cert.covered': '已覆盖',
  'cdn.https.cert.uncovered': '未覆盖',
  'cdn.https.cert.uncoveredTip':
    '当前手动证书未覆盖全部站点域名，相关域名的 HTTPS 访问可能出现证书错误。',
  'cdn.https.cert.domainState': '域名状态',
  'cdn.https.cert.domainReady': '已启用、已验证',
  'cdn.https.cert.recordId': '证书记录 ID',
  'cdn.https.cert.subject': '证书主题',
  'cdn.https.cert.serial': '序列号',
  'cdn.https.cert.fingerprint': 'SHA-256 指纹',
  'cdn.https.cert.publicKeyAlgorithm': '公钥算法',
  'cdn.https.cert.signatureAlgorithm': '签名算法',
  'cdn.https.cert.provider': 'ACME 服务商 ID',
  'cdn.https.cert.lastAttempt': '最近申请／续期记录时间',
  'cdn.https.cert.lastError': '最近失败原因',
  'cdn.https.cert.status.valid': '有效',
  'cdn.https.cert.status.expiring': '即将到期',
  'cdn.https.cert.status.expired': '已过期',
  'cdn.https.cert.status.not_yet_valid': '未生效',
  'cdn.https.cert.status.pending': '申请中',
  'cdn.https.cert.status.failed': '申请失败',
  'cdn.https.cert.status.invalid': '证书异常',
  'cdn.https.cert.status.missing': '未配置／未申请',
  'cdn.https.cert.status.revoked': '已吊销（记录状态）',
  'cdn.https.cert.status.unknown': '未知',
  'cdn.https.cert.attempt.success': '已签发',
  'cdn.https.cert.attempt.pending': '处理中',
  'cdn.https.cert.attempt.failed': '失败',
  'cdn.https.cert.attempt.none': '暂无记录',
  'cdn.https.cert.reason.domain_disabled': '域名未启用',
  'cdn.https.cert.reason.domain_unverified': '域名未验证',
  'cdn.https.cert.reason.site_inactive': '站点未上线',
  'cdn.https.cert.reason.https_disabled': 'HTTPS 已关闭',
  'cdn.https.cert.reason.awaiting_certificate': '等待可用证书',
  'cdn.site.line.column.description': '线路描述',
  'cdn.domain.verification.title': '域名验证配置',
  'cdn.domain.verification.domain': '域名',
  'cdn.domain.verification.method': '验证方式',
  'cdn.domain.verification.method.cname': 'CNAME 验证',
  'cdn.domain.verification.method.txt': 'TXT 记录验证',
  'cdn.domain.verification.txt.recordType': '记录类型',
  'cdn.domain.verification.txt.hostRecord': '主机记录',
  'cdn.domain.verification.txt.recordValue': '记录值',
  'cdn.domain.verification.txt.instructions':
    '请在 DNS 服务商配置以下 TXT 记录：',
  'cdn.domain.verification.copy': '复制配置',
  'cdn.domain.verification.verifyNow': '立即验证',
  'cdn.domain.verification.cancel': '取消',
  'cdn.domain.verification.getVerificationInfo': '获取验证信息',
  'cdn.domain.verification.success': '验证成功',
  'cdn.domain.verification.failed': '验证失败',
  'cdn.domain.verification.txtNotMatch': 'TXT 记录值不匹配，请检查 DNS 配置',
  'cdn.domain.verification.cnameNotMatch': 'CNAME 记录不匹配，请检查 DNS 配置',
  'cdn.domain.verification.dnsCheckFailed': 'DNS 查询失败',
  'cdn.domain.verification.cname.instructions':
    'CNAME 验证需要将域名指向站点配置的线路 CNAME 地址。请在"线路管理"中配置线路，并将域名 CNAME 记录指向对应的线路地址。',
  'cdn.domain.verification.tutorial.title': '配置教程',
  'cdn.domain.verification.tutorial.description':
    '下方提供了不同 DNS 服务商的配置示例供您参考，常见的 DNS 服务商有：阿里云、腾讯云、华为云、百度云。',
  'cdn.domain.verification.tutorial.aliyun': '阿里云',
  'cdn.domain.verification.tutorial.tx': '腾讯云',
  'cdn.domain.verification.tutorial.hw': '华为云',
  'cdn.domain.verification.tutorial.bd': '百度云',

  // 上游节点错误码
  'cdn.upstream.error.ADDRESS_REQUIRED': '上游节点地址不能为空',
  'cdn.upstream.error.PORT_INVALID': '端口必须在 1 到 65535 之间',
  'cdn.upstream.error.WEIGHT_INVALID': '权重必须在 0 到 {max} 之间',
  'cdn.upstream.error.TLS_SERVER_NAME_TOO_LONG':
    'TLS 服务器名称不能超过 {max} 个字符',
  'cdn.upstream.error.DIAL_TIMEOUT_INVALID':
    '连接超时必须在 0 到 {max} 毫秒之间',
  'cdn.upstream.error.RESPONSE_HEADER_TIMEOUT_INVALID':
    '响应头超时必须在 0 到 {max} 毫秒之间',
  'cdn.upstream.error.MAX_CONNS_PER_HOST_INVALID':
    '每主机最大连接数必须在 0 到 {max} 之间',
  'cdn.upstream.error.H2C_HTTPS_CONFLICT': 'H2C 与 HTTPS 不能同时启用',
  'cdn.upstream.error.H2C_HTTP3_CONFLICT': 'H2C 与 HTTP/3 不能同时启用',
  'cdn.upstream.error.FORCE_HTTP2_H2C_CONFLICT':
    '强制 HTTP/2 与 H2C 不能同时启用',
  'cdn.upstream.error.CERT_KEY_MISMATCH': 'TLS 证书和私钥必须同时提供',
  'cdn.upstream.error.TLS_CERT_WITHOUT_HTTPS':
    'TLS 证书/CA 仅在启用 HTTPS 时有效',
  'cdn.upstream.error.SKIP_VERIFY_WITH_CA':
    '不能同时设置跳过 TLS 验证和自定义 CA 证书',
  'cdn.upstream.error.TLS_SERVER_NAME_WITHOUT_HTTPS':
    'TLS 服务器名称仅在启用 HTTPS 时有效',

  // 上游节点字段提示
  'cdn.upstream.field.weight.tooltip': '范围 0~10000，默认 1',
  'cdn.upstream.field.dial_timeout.tooltip':
    '连接超时（毫秒），默认 3000（3秒）',
  'cdn.upstream.field.response_header_timeout.tooltip':
    '响应头超时（毫秒），默认 30000（30秒）',
  'cdn.upstream.field.max_conns_per_host.tooltip':
    '每主机最大连接数，0 表示不限制',
  'cdn.upstream.field.tls_server_name.tooltip': 'TLS SNI 名称，最长 255 字符',
  'cdn.upstream.field.enable_h2c.tooltip':
    '明文 HTTP/2，与 HTTPS 和 HTTP/3 互斥',
  'cdn.upstream.field.enable_http3.tooltip': 'HTTP/3 (QUIC)，将自动开启 HTTPS',
  'cdn.upstream.field.force_attempt_http2.tooltip': '强制 HTTP/2，与 H2C 互斥',
  'cdn.upstream.field.hostname.tooltip':
    '请求头 Host 字段，与 TLS SNI 名称不同',

  // 通用
  'cdn.common.confirm': '确定',
  'cdn.common.cancel': '取消',
  'cdn.common.delete': '删除',
  'cdn.common.edit': '编辑',
  'cdn.common.detail': '详情',
  'cdn.common.save': '保存',
  'cdn.common.saveConfig': '保存配置',
  'cdn.common.refresh': '刷新',
  'cdn.common.enable': '启用',
  'cdn.common.disable': '禁用',
  'cdn.common.enabled': '已启用',
  'cdn.common.disabled': '已禁用',
  'cdn.common.status': '状态',
  'cdn.common.operation': '操作',
  'cdn.common.copySuccess': '已复制',
  'cdn.common.name': '名称',
  'cdn.common.description': '描述',
  'cdn.common.type': '类型',
  'cdn.common.content': '匹配内容',
  'cdn.common.action': '动作',
  'cdn.common.redirectUrl': '重定向 URL',
  'cdn.common.addRule': '添加规则',
  'cdn.common.deleteConfirm': '确定要删除此规则吗？',
  'cdn.common.deleteSuccess': '删除成功',
  'cdn.common.deleteFailed': '删除失败',
  'cdn.common.createSuccess': '创建成功',
  'cdn.common.createFailed': '创建失败',
  'cdn.common.updateSuccess': '更新成功',
  'cdn.common.updateFailed': '更新失败',
  'cdn.common.saveSuccess': '保存成功',
  'cdn.common.saveFailed': '保存失败',
  'cdn.common.fetchFailed': '获取配置失败',
  'cdn.common.allow': '允许',
  'cdn.common.deny': '拒绝',
  'cdn.common.redirect': '重定向',
  'cdn.common.operationFailed': '操作失败',
  'cdn.common.yes': '是',
  'cdn.common.no': '否',

  // 匹配方式
  'cdn.match.ip': 'IP',
  'cdn.match.ip_group': 'IP 组',
  'cdn.match.uri': 'URI',
  'cdn.match.full_uri': '完整 URI',
  'cdn.match.uri_param': 'URI 参数',
  'cdn.match.user_agent': 'User-Agent',
  'cdn.match.referer': 'Referer',
  'cdn.match.header': '请求头',
  'cdn.match.equals': '等于',
  'cdn.match.not_equals': '不等于',
  'cdn.match.starts_with': '开头匹配',
  'cdn.match.ends_with': '结尾匹配',
  'cdn.match.contains': '包含',
  'cdn.match.regex': '正则',
  'cdn.match.in': '在列表中',
  'cdn.match.not_in': '不在列表中',

  // 验证方式
  'cdn.verify.click': '点击验证（默认）',
  'cdn.verify.slide': '滑动验证',
  'cdn.verify.slideRegion': '区域滑动验证',
  'cdn.verify.rotate': '旋转验证',

  // 带宽限制
  'cdn.bandwidthLimit.title': '带宽限制',
  'cdn.bandwidthLimit.enabled': '启用带宽限制',
  'cdn.bandwidthLimit.rate': '限速（Mbps）',

  // CC 防护
  'cdn.cc.form.title': 'CC 防护配置',
  'cdn.cc.form.verifyPolicy': '验证方式',
  'cdn.cc.form.verifyPolicyTip': '触发 CC 防护时的验证方式',
  'cdn.cc.form.verifyPolicyRequired': '请选择验证方式',
  'cdn.cc.form.banDuration': '封禁时长',
  'cdn.cc.form.banDurationTip': '触发防护后的封禁时长，如 60s、5m、1h',
  'cdn.cc.form.banDurationRequired': '请输入封禁时长',
  'cdn.cc.rules.title': 'CC 防护规则',
  'cdn.cc.rules.addTitle': '添加 CC 防护规则',
  'cdn.cc.rules.matchTarget': '匹配对象',
  'cdn.cc.rules.operator': '运算符',
  'cdn.cc.rules.actionAllow': '放行',
  'cdn.cc.rules.actionVerify': '验证',
  'cdn.cc.rules.countPeriod': '统计周期',
  'cdn.cc.rules.threshold': '请求阈值',
  'cdn.cc.rules.required.name': '请输入规则名称',
  'cdn.cc.rules.required.matchTarget': '请选择匹配对象',
  'cdn.cc.rules.required.operator': '请选择运算符',
  'cdn.cc.rules.required.content': '请输入匹配内容',
  'cdn.cc.rules.required.action': '请选择动作',
  'cdn.cc.rules.required.verifyPolicy': '请选择验证方式',
  'cdn.cc.rules.required.banDuration': '请输入封禁时长',
  'cdn.cc.rules.required.countPeriod': '请输入统计周期',
  'cdn.cc.rules.placeholder.duration': '如 60s、5m、1h',
  'cdn.cc.rules.descPlaceholder': '规则描述（可选）',
  'cdn.cc.rules.countPeriodTip': '在此时间窗口内统计请求次数',
  'cdn.cc.rules.thresholdTip': '触发规则的最大请求次数（1-100000）',
  'cdn.cc.rules.required.threshold': '请输入请求阈值',
  'cdn.cc.rules.regexTip': '正则表达式',
  'cdn.cc.rules.regexPlaceholder': '输入正则表达式',
  'cdn.cc.rules.content.ipPlaceholder':
    '如 1.2.3.4 或 1.2.0.0/16，多个 IP 用换行分隔',
  'cdn.cc.rules.content.ipMsg':
    '请输入合法的 IPv4 地址或 CIDR，如 1.2.3.4 或 1.2.0.0/16',
  'cdn.cc.rules.content.ipGroupPlaceholder': '输入 IP 组名称',
  'cdn.cc.rules.content.uriPlaceholder': '如 /api/v1/，以 / 开头',
  'cdn.cc.rules.content.uriMsg': 'URI 须以 / 开头',
  'cdn.cc.rules.content.fullUriPlaceholder': '如 https://example.com/path',
  'cdn.cc.rules.content.fullUriMsg': '完整 URI 须以 http:// 或 https:// 开头',
  'cdn.cc.rules.content.uriParamPlaceholder': '如 token 或 token=value',

  // CDN 缓存
  'cdn.cache.form.title': '缓存配置',
  'cdn.cache.form.defaultExpiry': '默认过期时间',
  'cdn.cache.form.day': '天',
  'cdn.cache.form.hour': '小时',
  'cdn.cache.form.minute': '分钟',
  'cdn.cache.form.second': '秒',
  'cdn.cache.form.required.duration': '请输入时长',
  'cdn.cache.rules.title': '缓存规则',
  'cdn.cache.rules.addTitle': '添加缓存规则',
  'cdn.cache.rules.type.regex': '正则',
  'cdn.cache.rules.type.suffix': '后缀',
  'cdn.cache.rules.type.prefix': '前缀',
  'cdn.cache.rules.type.exact': '精确',
  'cdn.cache.rules.type.all': '全部',
  'cdn.cache.rules.mode.follow': '遵循源站 Cache-Control',
  'cdn.cache.rules.mode.force': '强制缓存',
  'cdn.cache.rules.mode.noCache': '不缓存',
  'cdn.cache.rules.column.ruleType': '规则类型',
  'cdn.cache.rules.column.cacheMode': '缓存模式',
  'cdn.cache.rules.column.rangeProxy': 'Range 回源',
  'cdn.cache.rules.column.cacheTime': '缓存时间',
  'cdn.cache.rules.required.name': '请输入规则名称',
  'cdn.cache.rules.required.type': '请选择规则类型',
  'cdn.cache.rules.required.content': '请输入匹配内容',
  'cdn.cache.rules.required.mode': '请选择缓存模式',
  'cdn.cache.rules.required.time': '请输入缓存时间',
  'cdn.cache.rules.placeholder.time': '如 1d、2h',
  'cdn.cache.rules.placeholder.regex': '^/api/.*（正则表达式）',
  'cdn.cache.rules.placeholder.suffix':
    '.jpg,.png,.css（以 . 开头，多个用逗号分隔）',
  'cdn.cache.rules.placeholder.prefix': '/api/v1/（以 / 开头）',
  'cdn.cache.rules.placeholder.exact': '/index.html（精确路径，以 / 开头）',
  'cdn.cache.rules.validate.regex': '请输入合法的正则表达式',
  'cdn.cache.rules.validate.suffix':
    '后缀须以 . 开头，多个用逗号分隔，如 .jpg,.png',
  'cdn.cache.rules.validate.prefix': '前缀须以 / 开头',
  'cdn.cache.rules.validate.exact': '精确路径须以 / 开头',

  // CORS
  'cdn.cors.form.title': 'CORS 配置',
  'cdn.cors.form.enabled': '启用 CORS',
  'cdn.cors.form.origins': '允许的来源',
  'cdn.cors.form.originsTip': '输入来源后按回车添加，如 https://example.com',
  'cdn.cors.form.methods': '允许的 HTTP 方法',
  'cdn.cors.form.methodsPlaceholder': '选择允许的 HTTP 方法',
  'cdn.cors.form.headers': '允许的请求头',
  'cdn.cors.form.headersTip': '输入请求头后按回车添加，如 Content-Type',
  'cdn.cors.form.credentials': '允许携带凭证 (credentials)',
  'cdn.cors.form.exposeHeaders': '暴露的响应头',
  'cdn.cors.form.exposeHeadersTip': '输入响应头后按回车添加',
  'cdn.cors.form.maxAge': '预检请求缓存时间',
  'cdn.cors.form.maxAgeTip': 'OPTIONS 预检结果缓存秒数',

  // 域名管理
  'cdn.domain.table.title': '域名管理',
  'cdn.domain.table.addDomain': '添加域名',
  'cdn.domain.table.column.domain': '域名',
  'cdn.domain.table.column.primary': '主域名',
  'cdn.domain.table.column.verifyStatus': '验证状态',
  'cdn.domain.table.column.icpStatus': 'ICP状态',
  'cdn.domain.table.verified': '已验证',
  'cdn.domain.table.unverified': '未验证',
  'cdn.domain.table.unset': '未设置',
  'cdn.domain.table.setPrimary': '设为主域名',
  'cdn.domain.table.verify': '验证',
  'cdn.domain.table.verifyIcp': '验证备案',
  'cdn.domain.table.deleteConfirm': '确定要删除此域名吗？',
  'cdn.domain.table.lastDomainDeleteBlocked':
    '站点至少需要保留一个域名，请先添加其他域名',
  'cdn.domain.table.setPrimarySuccess': '已将 {domain} 设为主域名',
  'cdn.domain.table.setPrimaryFailed': '设置失败',
  'cdn.domain.table.icpVerifySuccess': '备案验证成功: {status}',
  'cdn.domain.table.icpVerifyFailed': '备案验证失败',
  'cdn.domain.table.verifyFailed': '验证失败',
  'cdn.domain.table.addSuccess': '域名添加成功，请先验证后再启用',
  'cdn.domain.table.addFailed': '添加失败',
  'cdn.domain.table.domainPlaceholder': '如 example.com',

  // 地域控制
  'cdn.geo.form.title': '地域控制配置',
  'cdn.geo.form.unknownRegion': '未知地区处理方式',
  'cdn.geo.form.unknownRegionTip': '对未匹配任何规则的地区的默认处理动作',
  'cdn.geo.form.required.action': '请选择处理方式',
  'cdn.geo.rules.title': '地域控制规则',
  'cdn.geo.rules.addTitle': '添加地域控制规则',
  'cdn.geo.rules.column.region': '地区',
  'cdn.geo.rules.required.region': '请选择地区',
  'cdn.geo.rules.required.action': '请选择动作',
  'cdn.geo.rules.required.redirectUrl': '请输入重定向 URL',
  'cdn.geo.rules.placeholder.redirectUrl': 'https://example.com',
  'cdn.geo.country.cn': '中国 (CN)',
  'cdn.geo.country.us': '美国 (US)',
  'cdn.geo.country.jp': '日本 (JP)',
  'cdn.geo.country.kr': '韩国 (KR)',
  'cdn.geo.country.gb': '英国 (GB)',
  'cdn.geo.country.de': '德国 (DE)',
  'cdn.geo.country.fr': '法国 (FR)',
  'cdn.geo.country.ru': '俄罗斯 (RU)',
  'cdn.geo.country.br': '巴西 (BR)',
  'cdn.geo.country.in': '印度 (IN)',
  'cdn.geo.country.au': '澳大利亚 (AU)',
  'cdn.geo.country.ca': '加拿大 (CA)',
  'cdn.geo.country.sg': '新加坡 (SG)',
  'cdn.geo.country.hk': '香港 (HK)',
  'cdn.geo.country.tw': '台湾 (TW)',

  // Gzip 压缩
  'cdn.gzip.form.title': '压缩配置',
  'cdn.gzip.form.enabled': '启用 Gzip',
  'cdn.gzip.form.level': '压缩等级',
  'cdn.gzip.form.levelTip':
    '取值范围 1-9，等级越高压缩率越高，CPU 消耗也越大；推荐 6',
  'cdn.gzip.form.levelExtra': '范围：1（最快）- 9（最高压缩率），推荐值 6',
  'cdn.gzip.form.minSize': '最小压缩大小（字节）',

  // 自定义 Header
  'cdn.header.table.title': '自定义 Header',
  'cdn.header.table.addTitle': '添加头部',
  'cdn.header.table.editTitle': '编辑头部',
  'cdn.header.table.column.headerType': '头部类型',
  'cdn.header.table.column.headerName': '头部名称',
  'cdn.header.table.column.value': '值',
  'cdn.header.table.column.action': '动作',
  'cdn.header.table.column.matchRegex': '匹配正则',
  'cdn.header.table.column.replace': '替换内容',
  'cdn.header.table.type.request': '请求头',
  'cdn.header.table.type.response': '响应头',
  'cdn.header.table.action.set': '设置',
  'cdn.header.table.action.append': '追加',
  'cdn.header.table.action.delete': '删除',
  'cdn.header.table.action.rewrite': '重写',
  'cdn.header.table.deleteConfirm': '确定要删除此头部吗？',
  'cdn.header.table.required.type': '请选择头部类型',
  'cdn.header.table.required.name': '请输入头部名称',
  'cdn.header.table.required.action': '请选择动作',
  'cdn.header.table.required.regex': '请输入匹配正则',
  'cdn.header.table.required.replace': '请输入替换内容',
  'cdn.header.table.placeholder.name': '如 X-Custom-Header',
  'cdn.header.table.placeholder.value': '输入头部值',
  'cdn.header.table.placeholder.regex': '正则表达式，如 ^(.*)$',
  'cdn.header.table.placeholder.replace': '替换内容，如 $1-suffix',

  // HTTPS 配置
  'cdn.https.form.title': 'HTTPS 配置',
  'cdn.https.form.enabled': '启用 HTTPS',
  'cdn.https.form.autoSsl': '自动申请证书',
  'cdn.https.form.autoSslTip':
    '启用后由系统自动通过 ACME 申请 TLS 证书，无需手动填写证书内容',
  'cdn.https.form.forceRedirect': 'HTTP 强制跳转 HTTPS',
  'cdn.https.form.certPem': '证书公钥',
  'cdn.https.form.certPemTip': '自动申请证书时无需填写',
  'cdn.https.form.certPemPlaceholder':
    '请粘贴 PEM 格式证书内容（-----BEGIN CERTIFICATE-----）',
  'cdn.https.form.keyPem': '证书私钥',
  'cdn.https.form.keyPemPlaceholder':
    '请粘贴 PEM 格式私钥内容（-----BEGIN PRIVATE KEY-----）',

  // 人机验证
  'cdn.human.form.title': '人机验证配置',
  'cdn.human.form.verifyAll': '验证全部请求',
  'cdn.human.form.verifyAllTip': '开启后对所有请求进行人机验证，忽略规则匹配',
  'cdn.human.form.verifyPolicy': '验证方式',
  'cdn.human.form.verifyPolicyRequired': '请选择验证方式',
  'cdn.human.form.verifyPeriod': '验证有效期',
  'cdn.human.form.verifyPeriodTip': '验证通过后的有效时长，如 60s、5m、1h',
  'cdn.human.form.verifyPeriodPlaceholder': '如 60s',
  'cdn.human.form.verifyPeriodRequired': '请输入有效期',
  'cdn.human.rules.title': '验证规则',
  'cdn.human.rules.addTitle': '添加人机验证规则',
  'cdn.human.rules.column.matchMode': '匹配方式',
  'cdn.human.rules.column.operator': '操作符',
  'cdn.human.rules.column.period': '有效期',
  'cdn.human.rules.required.name': '请输入规则名称',
  'cdn.human.rules.required.matchMode': '请选择匹配方式',
  'cdn.human.rules.required.operator': '请选择操作符',
  'cdn.human.rules.placeholder.content': '多个值使用 | 分隔',
  'cdn.human.rules.required.content': '请输入匹配内容',
  'cdn.human.rules.required.verifyPolicy': '请选择验证方式',
  'cdn.human.rules.required.verifyPeriod': '请输入有效期',

  // IP 访问控制
  'cdn.ipAccess.form.title': 'IP 访问控制配置',
  'cdn.ipAccess.form.defaultAction': '默认动作',
  'cdn.ipAccess.form.required.action': '请选择默认动作',
  'cdn.ipAccess.rules.title': 'IP 规则',
  'cdn.ipAccess.rules.addTitle': '添加 IP 访问控制规则',
  'cdn.ipAccess.rules.column.ip': 'IP',
  'cdn.ipAccess.rules.column.policy': '访问策略',
  'cdn.ipAccess.rules.placeholder.ip': '如 192.168.1.1 或 192.168.1.0/24',
  'cdn.ipAccess.rules.required.ip': '请输入 IP 地址',
  'cdn.ipAccess.rules.required.policy': '请选择访问策略',

  // 语言控制
  'cdn.language.form.title': '语言控制配置',
  'cdn.language.form.defaultLanguage': '默认语言',
  'cdn.language.form.defaultLanguagePlaceholder': '如 zh-CN',
  'cdn.language.form.autoDetect': '自动检测语言',
  'cdn.language.form.required.language': '请输入默认语言',
  'cdn.language.rules.title': '语言规则',
  'cdn.language.rules.addTitle': '添加语言规则',
  'cdn.language.rules.column.languages': '语言列表',
  'cdn.language.rules.placeholder.languages':
    '多个语言用逗号分隔，如 zh-CN, en-US',
  'cdn.language.rules.required.languages': '请输入语言代码',
  'cdn.language.rules.required.action': '请选择动作',
  'cdn.language.rules.placeholder.redirectUrl': '如 https://example.com/',
  'cdn.language.rules.required.redirectUrl': '请输入重定向 URL',

  // 防盗链
  'cdn.referer.form.title': '防盗链配置',
  'cdn.referer.form.stripQuery': '截断查询字符串',
  'cdn.referer.form.stripQueryTip': '计算防盗链时是否忽略 URL 中的查询参数',
  'cdn.referer.rules.title': '防盗链规则',
  'cdn.referer.rules.addTitle': '添加防盗链规则',
  'cdn.referer.rules.column.url': 'URL',

  'cdn.referer.rules.required.url': '请输入 URL',

  // 站点详情
  'cdn.site.title': '站点详情',
  'cdn.site.status': '状态：',
  'cdn.site.changeStatus': '更改状态',
  'cdn.site.fetchFailed': '获取站点详情失败：',
  'cdn.site.notFound': '站点不存在',
  'cdn.site.statusModal.title': '更改站点状态',
  'cdn.site.statusModal.currentStatus': '当前状态：',
  'cdn.site.statusModal.selectNew': '选择新状态：',
  'cdn.site.statusModal.onlineNote':
    '上线前需要验证：至少一个已验证域名、源站配置完整、线路配置完整',
  'cdn.site.statusModal.noChange': '状态未改变',
  'cdn.site.statusModal.updateSuccess': '状态更新成功',
  'cdn.site.statusModal.updateFailed': '状态更新失败',
  'cdn.site.statusModal.confirm': '确认',

  // 负载均衡
  'cdn.upstream.form.title': '负载均衡配置',
  'cdn.upstream.form.strategy': '负载均衡策略',
  'cdn.upstream.form.strategy.random': '随机',
  'cdn.upstream.form.strategy.roundRobin': '轮询',
  'cdn.upstream.form.strategy.leastConn': '最少连接',
  'cdn.upstream.form.strategy.ipHash': 'IP Hash',
  'cdn.upstream.form.strategy.weightedRR': '加权轮询',
  'cdn.upstream.form.required.strategy': '请选择负载均衡策略',
  'cdn.upstream.servers.title': '回源服务器列表',
  'cdn.upstream.servers.column.address': '地址',
  'cdn.upstream.servers.column.port': '端口',
  'cdn.upstream.servers.column.weight': '权重',
  'cdn.upstream.servers.column.https': 'HTTPS',
  'cdn.upstream.servers.column.protocol': '协议',
  'cdn.upstream.servers.column.note': '备注',
  'cdn.upstream.servers.deleteConfirm': '确定要删除此服务器吗？',
  'cdn.upstream.servers.mtls.title': '客户端证书（可选）',
  'cdn.upstream.servers.mtls.description':
    '以下公私钥用于双向 TLS（mTLS）场景：当上游服务器要求验证客户端身份时填写。普通 HTTPS 回源无需填写，留空即可。公钥与私钥必须同时提供或同时留空。',
  'cdn.upstream.servers.mtls.privateKey': '客户端私钥',
  'cdn.upstream.servers.mtls.privateKeyPlaceholder':
    '可选，双向 TLS 时填写。粘贴私钥内容（PEM 格式，以 -----BEGIN ... KEY----- 开头）',
  'cdn.upstream.servers.mtls.privateKeyTip':
    '双向 TLS（mTLS）客户端私钥，普通 HTTPS 回源无需填写',

  // URL 访问控制
  'cdn.urlAccess.form.title': 'URL 访问控制配置',
  'cdn.urlAccess.form.defaultAction': '默认动作',
  'cdn.urlAccess.form.required.action': '请选择默认动作',
  'cdn.urlAccess.rules.title': 'URL 访问规则',
  'cdn.urlAccess.rules.addTitle': '添加 URL 访问控制规则',
  'cdn.urlAccess.rules.column.operator': '操作符',
  'cdn.urlAccess.rules.op.exactMatch': '完全匹配',
  'cdn.urlAccess.rules.op.prefixMatch': '前缀匹配',
  'cdn.urlAccess.rules.op.suffixMatch': '后缀匹配',
  'cdn.urlAccess.rules.op.contains': '包含',
  'cdn.urlAccess.rules.op.regexMatch': '正则匹配',
  'cdn.urlAccess.rules.action.allow': '放行',
  'cdn.urlAccess.rules.required.name': '请输入规则名称',
  'cdn.urlAccess.rules.required.operator': '请选择操作符',
  'cdn.urlAccess.rules.placeholder.content': '输入 URL 匹配内容',
  'cdn.urlAccess.rules.required.content': '请输入匹配内容',
  'cdn.urlAccess.rules.required.action': '请选择动作',
  'cdn.urlAccess.rules.placeholder.redirectUrl':
    '如 https://example.com/new-path',
  'cdn.urlAccess.rules.required.redirectUrl': '请输入重定向 URL',

  // URL 鉴权
  'cdn.urlAuth.form.title': 'URL 鉴权配置',
  'cdn.urlAuth.form.statusTip': '启用或禁用 URL 鉴权功能',
  'cdn.urlAuth.info.title': '鉴权参数',
  'cdn.urlAuth.info.siteId': '站点 ID',
  'cdn.urlAuth.info.domains': '可用域名',
  'cdn.urlAuth.info.signatureBase': '签名原文格式',
  'cdn.urlAuth.info.urlParams': 'URL 参数',
  'cdn.urlAuth.info.param.expires': '过期时间（Unix 时间戳）',
  'cdn.urlAuth.info.param.key': '密钥 ID',
  'cdn.urlAuth.info.param.signature': '签名（Hex 编码）',
  'cdn.urlAuth.keys.title': '鉴权密钥',
  'cdn.urlAuth.keys.generateKey': '生成密钥',
  'cdn.urlAuth.keys.modal.title': '生成鉴权密钥',
  'cdn.urlAuth.keys.form.algorithm': '算法',
  'cdn.urlAuth.keys.required.algorithm': '请选择算法',
  'cdn.urlAuth.keys.createSuccess': '密钥生成成功',
  'cdn.urlAuth.keys.deleteConfirm': '确定要删除此密钥吗？删除后将无法恢复。',
  'cdn.urlAuth.keys.column.keyId': '密钥 ID',
  'cdn.urlAuth.keys.column.algorithm': '算法',
  'cdn.urlAuth.keys.result.title': '密钥已生成 - 请立即保存',
  'cdn.urlAuth.keys.result.warning': '私钥仅显示一次，关闭后将无法再次查看！',
  'cdn.urlAuth.keys.result.keyId': '密钥 ID',
  'cdn.urlAuth.keys.result.algorithm': '算法',
  'cdn.urlAuth.keys.result.privateKey': '私钥',
  'cdn.urlAuth.keys.result.saved': '我已保存',
  'cdn.urlAuth.rules.title': '鉴权规则',
  'cdn.urlAuth.rules.action.auth': '需要鉴权',
  'cdn.urlAuth.rules.action.pass': '免鉴权',
  'cdn.urlAuth.rules.modal.title': '添加鉴权规则',
  'cdn.urlAuth.rules.editTitle': '编辑鉴权规则',
  'cdn.urlAuth.rules.form.contentPlaceholder':
    '输入 URL 路径，如 /video/ 或 /api/*',
  'cdn.urlAuth.rules.form.actionTip':
    '需要鉴权：匹配的 URL 需要携带签名参数；免鉴权：匹配的 URL 无需签名即可访问',
  'cdn.urlAuth.rules.required.name': '请输入规则名称',
  'cdn.urlAuth.rules.required.operator': '请选择操作符',
  'cdn.urlAuth.rules.required.content': '请输入匹配内容',
  'cdn.urlAuth.rules.required.action': '请选择动作',

  // URL 鉴权使用说明
  'cdn.urlAuth.instructions.title': 'URL 鉴权使用说明',
  'cdn.urlAuth.instructions.principle': '鉴权原理',
  'cdn.urlAuth.instructions.principle.desc':
    'URL 鉴权通过数字签名保护 CDN 资源，防止未授权访问。',
  'cdn.urlAuth.instructions.principle.item1':
    '内容提供商使用私钥对 URL 进行签名',
  'cdn.urlAuth.instructions.principle.item2':
    'CDN 边缘节点使用公钥验证签名的有效性',
  'cdn.urlAuth.instructions.principle.item3':
    '签名通过后，鉴权参数会被剥离，不影响缓存命中率',
  'cdn.urlAuth.instructions.principle.item4':
    '支持 Ed25519（推荐）和 HMAC-SHA256 两种算法',
  'cdn.urlAuth.instructions.flow': '签名流程',
  'cdn.urlAuth.instructions.flow.step1':
    '构造签名原文: site_id|host|path|expires',
  'cdn.urlAuth.instructions.flow.step2': '使用私钥对签名原文进行签名',
  'cdn.urlAuth.instructions.flow.step3': '将签名结果进行 Hex 编码',
  'cdn.urlAuth.instructions.flow.step4': '将签名参数拼接到 URL 中',
  'cdn.urlAuth.instructions.urlFormat': 'URL 格式',
  'cdn.urlAuth.instructions.paramExpires': 'x-cdn-auth-expires',
  'cdn.urlAuth.instructions.paramExpires.desc': '过期时间，Unix 时间戳（秒）',
  'cdn.urlAuth.instructions.paramKey': 'x-cdn-auth-key',
  'cdn.urlAuth.instructions.paramKey.desc': '密钥 ID，即密钥的 record_id',
  'cdn.urlAuth.instructions.paramSig': 'x-cdn-auth-signature',
  'cdn.urlAuth.instructions.paramSig.desc': 'Hex 编码的签名',
  'cdn.urlAuth.instructions.codeExamples': '代码示例',
  'cdn.urlAuth.instructions.codeExamples.desc':
    '以下是各语言生成签名 URL 的完整示例代码，可直接复制使用。',
  'cdn.urlAuth.instructions.codeExamples.tip':
    '如果您的开发语言不在上述列表中，可参考以上代码逻辑，让 AI 帮您生成对应语言的实现。',

  // URL 重写
  'cdn.urlRewrite.form.title': 'URL 重写配置',
  'cdn.urlRewrite.form.description':
    'URL 重写功能已通过右上角开关控制。通过"规则"标签页管理重写规则。',
  'cdn.urlRewrite.rules.title': '重写规则',
  'cdn.urlRewrite.rules.addTitle': '添加 URL 重写规则',
  'cdn.urlRewrite.rules.column.pattern': '匹配模式',
  'cdn.urlRewrite.rules.column.replacement': '替换内容',
  'cdn.urlRewrite.rules.placeholder.pattern': '如 ^/old/(.*)$',
  'cdn.urlRewrite.rules.required.pattern': '请输入匹配模式',
  'cdn.urlRewrite.rules.placeholder.replacement': '如 /new/$1',
  'cdn.urlRewrite.rules.required.replacement': '请输入替换内容',

  // UA 控制
  'cdn.ua.form.title': 'UA 控制配置',
  'cdn.ua.form.unknownUa': '未知 UA 处理方式',
  'cdn.ua.form.unknownUaTip': '对未匹配任何规则的 User-Agent 的默认处理动作',
  'cdn.ua.form.action.allowDefault': '放行（默认）',
  'cdn.ua.form.required.action': '请选择处理方式',
  'cdn.ua.rules.title': 'UA 控制规则',
  'cdn.ua.rules.addTitle': '添加 UA 控制规则',
  'cdn.ua.rules.column.ua': 'User-Agent',
  'cdn.ua.rules.action.allow': '放行',
  'cdn.ua.rules.action.allowNote': '允许访问',
  'cdn.ua.rules.placeholder.ua': '如 Mozilla/5.0 或关键词片段',
  'cdn.ua.rules.required.ua': '请输入 User-Agent',
  'cdn.ua.rules.required.action': '请选择动作',
  'cdn.ua.rules.placeholder.redirectUrl': 'https://example.com',
  'cdn.ua.rules.required.redirectUrl': '请输入重定向 URL',

  // WAF
  'cdn.waf.form.title': 'WAF 防护配置',

  // DNS
  'cdn.dns.title': 'DNS 记录',
  'cdn.dns.providerPlaceholder': 'DNS 供应商（可选）',
  'cdn.dns.column.name': '记录名称',
  'cdn.dns.column.type': '记录类型',
  'cdn.dns.column.value': '记录值',
  'cdn.dns.column.ttl': 'TTL',
  'cdn.dns.column.priority': '优先级',

  // 线路管理
  'cdn.line.title': '线路管理',
  'cdn.line.createTitle': '创建线路',
  'cdn.line.editTitle': '编辑线路',
  'cdn.line.createButton': '创建线路',
  'cdn.line.required.name': '请输入线路名称',
  'cdn.line.deleteConfirm': '确定要删除此线路吗？',

  // 监控
  'cdn.monitor.traffic': '流量统计',
  'cdn.monitor.totalTraffic': '总流量',
  'cdn.monitor.currentBandwidth': '当前带宽',
  'cdn.monitor.bandwidthUnit': '/s',
  'cdn.monitor.peakBandwidth': '峰值带宽',
  'cdn.monitor.requests': '请求统计',
  'cdn.monitor.totalRequests': '总请求数',
  'cdn.monitor.currentQps': '当前 QPS',
  'cdn.monitor.qpsUnit': '次/秒',
  'cdn.monitor.peakQps': '峰值 QPS',

  // 节点管理
  'cdn.node.title': '节点管理',
  'cdn.node.list.title': '节点列表',
  'cdn.node.column.deviceCode': '设备编码',
  'cdn.node.column.version': '版本',
  'cdn.node.column.region': '区域',
  'cdn.node.column.healthStatus': '健康状态',
  'cdn.node.column.status': '状态',
  'cdn.node.column.ip': 'IP 地址',
  'cdn.node.column.lines': '关联线路',
  'cdn.node.column.expiredAt': '过期时间',
  'cdn.node.column.updatedAt': '更新时间',
  'cdn.node.column.hostname': '主机名',
  'cdn.node.status.online': '在线',
  'cdn.node.status.offline': '离线',
  'cdn.node.status.pending': '等待上线',
  'cdn.node.status.upgrading': '升级中',
  'cdn.node.status.migrating': '迁移中',
  'cdn.node.status.trafficOverLimit': '流量超限',
  'cdn.node.status.expired': '已过期',
  'cdn.node.health.healthy': '健康',
  'cdn.node.health.unhealthy': '不健康',
  'cdn.node.health.unknown': '未知',
  'cdn.node.health.unregister': '未注册',
  'cdn.node.updateStatus': '更新状态',
  'cdn.node.updateExpiredAt': '更新过期时间',
  'cdn.node.deleteConfirm': '确定要删除此节点吗？',
  'cdn.node.modal.title': '更新节点状态',
  'cdn.node.modal.deviceCode': '设备编码',
  'cdn.node.modal.required.status': '请选择状态',
  'cdn.node.modal.updateSuccess': '状态更新成功',
  'cdn.node.modal.updateFailed': '更新状态失败',

  // 节点 IP 管理
  'cdn.nodeIp.title': '节点 IP 管理',
  'cdn.nodeIp.addButton': '添加 IP',
  'cdn.nodeIp.createTitle': '添加 IP',
  'cdn.nodeIp.editDnsLineTitle': '修改 DNS 线路',
  'cdn.nodeIp.editDnsLine': '改线路',
  'cdn.nodeIp.column.ip': 'IP',
  'cdn.nodeIp.column.ipType': '类型',
  'cdn.nodeIp.column.dnsLine': 'DNS 线路',
  'cdn.nodeIp.column.createdAt': '创建时间',
  'cdn.nodeIp.form.ipType': '类型',
  'cdn.nodeIp.form.ip': 'IP',
  'cdn.nodeIp.form.dnsLine': 'DNS 线路',
  'cdn.nodeIp.form.required.ipType': '请选择类型',
  'cdn.nodeIp.form.required.ip': '请输入 IP',
  'cdn.nodeIp.form.required.dnsLine': '请选择 DNS 线路',
  'cdn.nodeIp.form.placeholder.ip': '请输入 IP',
  'cdn.nodeIp.form.invalid.ipv4': 'IPv4 格式不正确',
  'cdn.nodeIp.form.invalid.ipv6': 'IPv6 格式不正确',
  'cdn.nodeIp.createSuccess': '添加成功',
  'cdn.nodeIp.createFailed': '添加失败',
  'cdn.nodeIp.updateDnsLineSuccess': '修改线路成功',
  'cdn.nodeIp.updateDnsLineFailed': '修改线路失败',
  'cdn.nodeIp.updateStatusSuccess': '状态更新成功',
  'cdn.nodeIp.updateStatusFailed': '状态更新失败',
  'cdn.nodeIp.deleteConfirm': '确定要删除此 IP 吗？',
  'cdn.nodeIp.loadFailed': '加载失败',
  'cdn.nodeIp.syncWarning':
    '手工添加/修改的 IP 可能在节点下次注册上报时被自动同步覆盖',
  'cdn.nodeIp.selectNode': '选择节点',
  'cdn.nodeIp.noNodeSelected': '未选择节点',
  'cdn.node.tab.ips': 'IP 管理',
  'cdn.node.tab.desc.ips':
    '管理节点的 IP 地址，包括 IPv4 和 IPv6 地址的添加、编辑和删除。',

  // 节点默认配置
  'cdn.node.defaultConfig.title': '节点默认配置',
  'cdn.node.defaultConfig.button': '全局默认配置',

  // 站点列表与创建
  'cdn.site.list.title': '站点管理',
  'cdn.site.list.createButton': '创建站点',
  'cdn.site.list.column.site': '站点',
  'cdn.site.list.column.accessType': '接入方式',
  'cdn.site.list.column.region': '区域',
  'cdn.site.list.column.tags': '标签',
  'cdn.site.list.column.updatedAt': '更新时间',
  'cdn.site.list.column.subscriptionType': '订阅类型',
  'cdn.site.list.deleteConfirm': '确定要删除此站点吗？',
  'cdn.site.create.basicInfo': '基本信息',
  'cdn.site.create.domain': '域名',
  'cdn.site.create.domainPlaceholder': '请输入站点域名，如 example.com',
  'cdn.site.create.domainRequired': '请输入域名',
  'cdn.site.create.domainInvalid': '请输入有效的域名格式',
  'cdn.site.create.siteName': '站点名称',
  'cdn.site.create.siteNamePlaceholder': '请输入站点名称（可选）',
  'cdn.site.create.regionTitle': '区域与接入',
  'cdn.site.create.selectRegion': '选择加速区域',
  'cdn.site.create.accessNote':
    '接入方式：CNAME（添加 CNAME 记录指向 CDN 提供的域名）',
  'cdn.site.create.selectPlan': '选择套餐',
  'cdn.site.create.selectPlanTitle': '选择服务套餐',
  'cdn.site.create.success': '站点创建成功',
  'cdn.site.create.failed': '创建失败',

  // 站点详情标签页
  'cdn.site.tab.domains': '域名管理',
  'cdn.site.tab.upstream': '回源配置',
  'cdn.site.tab.https': 'HTTPS 证书',
  'cdn.site.tab.cdn': '缓存规则',
  'cdn.site.tab.cc': 'CC 防护',
  'cdn.site.tab.waf': 'WAF 防护',
  'cdn.site.tab.geo': '地域限制',
  'cdn.site.tab.human': 'Bot 管理',
  'cdn.site.tab.gzip': '内容压缩',
  'cdn.site.tab.cors': 'CORS',
  'cdn.site.tab.referer': '防盗链',
  'cdn.site.tab.ua': 'UA 过滤',
  'cdn.site.tab.ipAccess': 'IP 黑白名单',
  'cdn.site.tab.urlAccess': 'URL 过滤',
  'cdn.site.tab.urlAuth': 'URL 鉴权',
  'cdn.site.tab.urlRewrite': 'URL 重写',
  'cdn.site.tab.headers': '请求头管理',
  'cdn.site.tab.language': '语言限制',
  'cdn.site.tab.bandwidthLimit': '带宽限速',

  // 站点详情侧边导航
  'cdn.site.sideMenu.backToList': '返回站点列表',
  'cdn.site.sideMenu.group.basic': '站点配置',
  'cdn.site.sideMenu.group.performance': '缓存优化',
  'cdn.site.sideMenu.group.security': '安全防护',
  'cdn.site.sideMenu.group.access': '访问限制',
  'cdn.site.sideMenu.group.advanced': '高级功能',
  'cdn.site.tab.config': '配置',
  'cdn.site.tab.rules': '规则',
  'cdn.site.tab.servers': '服务器列表',

  // 标签页描述
  'cdn.site.tab.desc.domains':
    '管理站点绑定的域名，包括主域名与备用域名的添加、删除和 DNS 验证。',
  'cdn.site.tab.desc.upstream':
    '配置回源目标服务器的地址、权重及连接参数，支持多源负载均衡与健康检查。',
  'cdn.site.tab.desc.https':
    '配置 SSL/TLS 证书绑定、强制 HTTPS 跳转、HSTS 以及 TLS 协议版本等安全传输选项。',
  'cdn.site.tab.desc.cdn':
    '控制内容在边缘节点的缓存策略，包括全局缓存时间、缓存模式以及基于路径/后缀的自定义缓存规则。',
  'cdn.site.tab.desc.cc':
    'CC（Challenge Collapsar）防护：通过全局配置与自定义规则限制访问频率，支持按 IP、URI、Header 等维度设置阈值，超过阈值后触发拦截或人机验证，有效防御高频请求攻击。',
  'cdn.site.tab.desc.waf':
    'Web 应用防火墙：检测并拦截 SQL 注入、XSS、命令注入等常见 Web 攻击，保护应用层安全。',
  'cdn.site.tab.desc.geo':
    '基于访客地理位置（国家/地区）进行访问控制，可通过白名单或黑名单过滤特定地区的流量。',
  'cdn.site.tab.desc.human':
    '通过行为分析识别真实用户与自动化爬虫，对可疑流量触发滑块或图形验证码挑战。',
  'cdn.site.tab.desc.gzip':
    '启用 Gzip/Brotli 响应压缩，减少传输体积，提升页面加载速度，降低带宽消耗。',
  'cdn.site.tab.desc.cors':
    '配置跨域资源共享（CORS）策略，控制哪些来源域名可以通过浏览器跨域访问本站资源。',
  'cdn.site.tab.desc.referer':
    '基于 HTTP Referer 头部限制资源访问来源，防止其他网站盗用图片、视频等静态资源。',
  'cdn.site.tab.desc.ua':
    '基于客户端 User-Agent 标识进行过滤，可拦截特定爬虫、扫描工具或恶意客户端程序。',
  'cdn.site.tab.desc.ipAccess':
    '基于客户端 IP 地址的访问控制，支持精确 IP 和 CIDR 网段的黑白名单管理。',
  'cdn.site.tab.desc.urlAccess':
    '基于请求 URL 路径的访问控制，可对特定路径或路径模式设置允许或拒绝访问规则。',
  'cdn.site.tab.desc.urlAuth':
    '通过签名验证保护资源，防止未授权访问。支持 Ed25519 和 HMAC-SHA256 算法。',
  'cdn.site.tab.desc.urlRewrite':
    '对请求 URL 进行 301/302 重定向或内部路径重写，支持正则表达式匹配和捕获组变量替换。',
  'cdn.site.tab.desc.headers':
    '自定义 HTTP 响应头或请求头，可添加安全头（如 X-Frame-Options）、修改缓存指令或删除敏感字段。',
  'cdn.site.tab.desc.language':
    '基于 Accept-Language 请求头进行访问过滤，可针对特定语言/地区的用户设置允许或拒绝策略。',
  'cdn.site.tab.desc.bandwidthLimit':
    '限制单连接或整体站点的下行带宽上限，防止带宽滥用、控制流量消耗速率。',

  // 站点节点 IP 白名单
  'cdn.site.nodeIps.fetchError': '获取节点 IP 列表失败',
  'cdn.site.nodeIps.title': 'CDN 回源 IP 白名单',
  'cdn.site.nodeIps.desc':
    '如果您的服务器开启了防火墙，需要将以下 CDN 节点 IP 添加到防火墙白名单中，否则 CDN 无法正常回源。',
  'cdn.site.nodeIps.hint': '如果您的服务器没有开启防火墙，可以忽略此配置。',
  'cdn.site.nodeIps.steps.title': '操作步骤：',
  'cdn.site.nodeIps.steps.1': '点击"复制全部"按钮复制 IP 地址',
  'cdn.site.nodeIps.copyAll': '复制全部',
  'cdn.site.nodeIps.steps.2': '登录您的服务器管理面板',
  'cdn.site.nodeIps.steps.3': '在防火墙/安全组规则中，添加这些 IP 为"允许访问"',
  'cdn.site.nodeIps.steps.4': '保存配置',
  'cdn.site.nodeIps.emptyIpv4': '暂无 IPv4 数据',
  'cdn.site.nodeIps.emptyIpv6': '暂无 IPv6 数据',

  // 节点状态更新
  'cdn.node.updateStatusSuccess': '状态更新成功',
  'cdn.node.updateStatusFailed': '更新状态失败',

  // 站点列表补充
  'cdn.site.list.viewDetail': '查看详情',

  // 站点创建补充
  'cdn.site.create.button': '创建站点',
  'cdn.site.create.step.basic': '基本信息',
  'cdn.site.create.step.region': '区域与接入',
  'cdn.site.create.step.plan': '选择套餐',
  'cdn.site.create.label.domain': '域名',
  'cdn.site.create.label.name': '站点名称',
  'cdn.site.create.placeholder.domain': '请输入站点域名，如 example.com',
  'cdn.site.create.placeholder.name': '请输入站点名称（可选）',
  'cdn.site.create.required.domain': '请输入域名',
  'cdn.site.create.required.domainFormat': '请输入有效的域名格式',
  'cdn.site.create.cnameHint':
    '接入方式：CNAME（添加 CNAME 记录指向 CDN 提供的域名）',

  // 监控补充
  'cdn.monitor.request': '请求统计',
  'cdn.monitor.title': '监控统计',
  'cdn.monitor.qpsSuffix': '次/秒',

  // 线路补充
  'cdn.line.column.createdAt': '创建时间',

  // 站点状态弹窗
  'cdn.site.statusModal.selectStatus': '选择新状态：',
  'cdn.site.statusModal.activateWarning':
    '上线前需要验证：至少一个已验证域名、源站配置完整、线路配置完整',

  // Gzip 压缩表单
  'cdn.gzip.form.enableGzip': '启用 Gzip',
  'cdn.gzip.form.levelTooltip':
    '取值范围 1-9，等级越高压缩率越高，CPU 消耗也越大；推荐 6',
  'cdn.gzip.form.minLength': '最小压缩大小（字节）',

  // 人机验证表单
  'cdn.human.form.expiry': '验证有效期',
  'cdn.human.form.expiryPlaceholder': '如 60s',

  // 回源负载均衡表单
  'cdn.upstream.form.lbTitle': '负载均衡配置',
  'cdn.upstream.form.lbStrategy': '负载均衡策略',
  'cdn.upstream.form.lbRandom': '随机',
  'cdn.upstream.form.lbRoundRobin': '轮询',

  // URL 访问控制表单

  // IP 访问控制表单

  // UA 控制表单

  // 防盗链表单

  // 语言控制表单

  // WAF 防护表单

  // URL 重写表单

  // CORS 表单

  // 匹配选项补充

  // 站点详情布局
  'cdn.site.tabLayout.notFound': '站点不存在',
  'cdn.site.tabLayout.title': '站点详情',
  'cdn.site.tabLayout.changeStatus': '更改状态',
  'cdn.common.statusLabel': '状态：',
  'cdn.status.active': '已启用',
  'cdn.status.inactive': '已停用',
  'cdn.status.pending': '待配置',
  'cdn.status.suspended': '已暂停',
  'cdn.status.arrears': '欠费',
  'cdn.status.transferred': '已转移',

  // 上游服务器
  'cdn.upstream.servers.serverSuffix': '服务器',

  // 域名表格
  'cdn.domain.table.setPrimarySuccessEnd': '设为主域名',

  // 域名验证弹窗
  'cdn.domain.verify.recordType': '记录类型',
  'cdn.domain.verify.hostRecord': '主机记录',
  'cdn.domain.verify.recordValue': '记录值',
  'cdn.domain.verify.copyTooltip': '复制配置信息',

  // Header 动作类型
  'cdn.header.table.action.add': '追加',
  'cdn.header.table.action.del': '删除',

  // 地域国家
  'cdn.geo.country.CN': '中国 (CN)',
  'cdn.geo.country.US': '美国 (US)',
  'cdn.geo.country.JP': '日本 (JP)',
  'cdn.geo.country.KR': '韩国 (KR)',
  'cdn.geo.country.GB': '英国 (GB)',
  'cdn.geo.country.DE': '德国 (DE)',
  'cdn.geo.country.FR': '法国 (FR)',
  'cdn.geo.country.RU': '俄罗斯 (RU)',

  // 通用短文本补充
  'cdn.common.enabledShort': '启用',
  'cdn.common.disabledShort': '禁用',

  // HTTPS 表单
  'cdn.https.form.enableHttps': '启用 HTTPS',
  'cdn.https.form.autoCert': '自动申请证书',
  'cdn.https.form.autoCertTip':
    '启用后由系统自动通过 ACME 申请 TLS 证书，无需手动填写证书内容',
  'cdn.https.form.httpRedirect': 'HTTP 强制跳转 HTTPS',
  'cdn.https.form.certPublicKey': '证书公钥',
  'cdn.https.form.certAutoCertPlaceholder': '自动申请证书时无需填写',
  'cdn.https.form.certPublicKeyPlaceholder':
    '请粘贴 PEM 格式证书内容（-----BEGIN CERTIFICATE-----）',
  'cdn.https.form.certPrivateKey': '证书私钥',
  'cdn.https.form.certPrivateKeyPlaceholder':
    '请粘贴 PEM 格式私钥内容（-----BEGIN PRIVATE KEY-----）',

  // 地域控制表单
  'cdn.geo.form.unknownAction': '未知地区处理方式',
  'cdn.geo.form.unknownActionTip': '对未匹配任何规则的地区的默认处理动作',

  // 缓存规则内容验证
  'cdn.cache.rules.content.regexPlaceholder': '^/api/.*（正则表达式）',
  'cdn.cache.rules.content.regexMsg': '请输入合法的正则表达式',
  'cdn.cache.rules.content.suffixPlaceholder':
    '.jpg|.png|.css（以 . 开头，多个用 | 分隔）',
  'cdn.cache.rules.content.suffixMsg':
    '后缀须以 . 开头，多个用 | 分隔，如 .jpg|.png',
  'cdn.cache.rules.content.prefixPlaceholder': '/api/v1/（以 / 开头）',
  'cdn.cache.rules.content.prefixMsg': '前缀须以 / 开头',
  'cdn.cache.rules.content.eqPlaceholder': '/index.html（精确路径，以 / 开头）',
  'cdn.cache.rules.content.eqMsg': '精确路径须以 / 开头',

  // 通用补充
  'cdn.common.value': '值',
  'cdn.common.matchContent': '匹配内容',
  'cdn.common.seconds': '秒',
  'cdn.common.domain': '域名',

  // 缓存规则列标题
  'cdn.cache.rules.column.content': '匹配内容',
  'cdn.cache.rules.column.ttl': '缓存时间',
  'cdn.cache.rules.column.mode': '缓存模式',
  'cdn.cache.rules.column.range': 'Range 回源',

  // 域名表格
  'cdn.domain.table.getVerifyFailed': '获取验证信息失败',
  'cdn.domain.table.verifySuccess': '验证成功',

  // 地域规则
  'cdn.geo.country.BR': '巴西 (BR)',
  'cdn.geo.country.IN': '印度 (IN)',
  'cdn.geo.country.AU': '澳大利亚 (AU)',
  'cdn.geo.country.CA': '加拿大 (CA)',
  'cdn.geo.country.SG': '新加坡 (SG)',
  'cdn.geo.country.HK': '香港 (HK)',
  'cdn.geo.country.TW': '台湾 (TW)',

  // Header 表格
  'cdn.header.table.requestHeader': '请求头',
  'cdn.header.table.responseHeader': '响应头',

  // 人机验证
  'cdn.human.form.expiryTip': '验证通过后的有效时长，如 60s、5m、1h',
  'cdn.human.rules.column.verifyPolicy': '验证方式',

  // IP 访问控制
  'cdn.ipAccess.rules.modal.title': '添加 IP 访问控制规则',
  'cdn.ipAccess.rules.form.ip': 'IP 地址',
  'cdn.ipAccess.rules.form.ipPlaceholder': '如 192.168.1.1 或 192.168.1.0/24',
  'cdn.ipAccess.rules.form.policy': '访问策略',

  // 语言规则
  'cdn.language.rules.modal.title': '添加语言规则',

  // 防盗链规则
  'cdn.referer.rules.modal.title': '添加防盗链规则',
  'cdn.referer.rules.editTitle': '编辑防盗链规则',
  'cdn.referer.rules.form.domainPlaceholder':
    '如 example.com、*.example.com 或 https://example.com',
  'cdn.referer.rules.column.matchType': '匹配方式',
  'cdn.referer.rules.matchType.wildcard': '通配符匹配',
  'cdn.referer.rules.matchType.equals': '精确匹配',
  'cdn.referer.rules.matchType.startsWith': '前缀匹配',
  'cdn.referer.rules.matchType.endsWith': '后缀匹配',
  'cdn.referer.rules.matchType.contains': '包含匹配',
  'cdn.referer.rules.matchType.regex': '正则表达式',
  'cdn.referer.rules.required.matchType': '请选择匹配方式',

  // 回源服务器表格
  'cdn.upstream.servers.column.remark': '备注',
  'cdn.upstream.form.lbLeastConn': '最少连接',
  'cdn.upstream.form.lbWeightedRR': '加权轮询',

  // URL 重写规则
  'cdn.urlRewrite.rules.modal.title': '添加 URL 重写规则',
  'cdn.urlRewrite.rules.form.pattern': '匹配模式',
  'cdn.urlRewrite.rules.form.patternPlaceholder': '如 ^/old/(.*)$',
  'cdn.urlRewrite.rules.form.replacement': '替换内容',

  // UA 规则
  'cdn.ua.rules.modal.title': '添加 UA 控制规则',
  'cdn.ua.rules.form.uaPlaceholder': '如 Mozilla/5.0 或关键词片段',

  // 站点列表（oper）
  'cdn.site.list.onlyMine': '仅查看自己的',
  'cdn.site.create.label.region': '区域',
  'cdn.site.region.chineseMainland': '中国大陆',
  'cdn.site.region.global': '全球',
  'cdn.site.region.globalExcludingCN': '全球(不含中国大陆)',
  'cdn.region.chinese_mainland': '中国大陆',
  'cdn.region.global': '全球',
  'cdn.region.global_excluding_chinese_mainland': '全球（不含中国大陆）',
  'cdn.region.selectPlaceholder': '请选择区域',

  // 线路管理
  'cdn.line.create.button': '创建线路',
  'cdn.line.create.title': '创建线路',
  'cdn.line.edit.title': '编辑线路',
  'cdn.line.create.required.name': '请输入线路名称',
  'cdn.line.create.placeholder.name': '请输入线路名称',
  'cdn.line.create.required.code': '请输入线路编码',
  'cdn.line.create.placeholder.code': '请输入线路编码，如 hk.free',
  'cdn.line.create.invalid.code':
    '线路编码仅支持小写字母、数字、连字符，可用点分隔多段',
  'cdn.line.detail.error': '获取线路详情失败',
  'cdn.line.detail.notFound': '线路不存在',
  'cdn.line.tab.basic': '基本信息',
  'cdn.line.tab.nodes': '节点配置',
  'cdn.line.sideMenu.group.basic': '线路信息',
  'cdn.line.sideMenu.backToList': '返回线路列表',
  'cdn.line.tab.desc.basic': '查看线路基本信息，包括名称、编码、区域、状态等。',
  'cdn.line.tab.desc.nodes': '管理线路关联的节点列表，支持批量添加和删除节点。',
  'cdn.line.column.name': '线路名称',
  'cdn.line.column.code': '线路编码',
  'cdn.line.column.region': '区域',
  'cdn.line.column.description': '描述',
  'cdn.line.status.active': '激活',
  'cdn.line.status.inactive': '未激活',
  'cdn.line.nodes.title': '线路节点配置',
  'cdn.line.nodes.loadFailed': '加载节点列表失败',
  'cdn.line.nodes.loadAvailableFailed': '加载可选节点失败',
  'cdn.line.nodes.addSuccess': '节点添加成功',
  'cdn.line.nodes.addFailed': '节点添加失败',
  'cdn.line.nodes.deleteSuccess': '节点删除成功',
  'cdn.line.nodes.deleteFailed': '节点删除失败',
  'cdn.line.nodes.selectAtLeastOne': '请至少选择一个节点',
  'cdn.line.nodes.add': '添加节点',
  'cdn.line.nodes.batchDelete': '批量删除',
  'cdn.line.nodes.deleteConfirm': '确定要删除此节点吗？',
  'cdn.line.nodes.batchDeleteConfirm': '确定要删除选中的节点吗？',
  'cdn.line.nodes.deleteLastNodeConfirmTitle': '确认删除最后一个节点',
  'cdn.line.nodes.deleteLastNodeConfirmContent':
    '这是该线路的最后一个节点，删除后该线路将没有任何节点，确定要删除吗？',
  'cdn.line.nodes.clearAllNodesConfirmTitle': '确认移除全部节点',
  'cdn.line.nodes.clearAllNodesConfirmContent':
    '此操作将移除该线路的全部节点，确定要继续吗？',
  'cdn.line.nodes.selectedCount': '已选择 {count} 个节点',
  'cdn.line.nodes.selectModal.title': '选择节点',
  'cdn.line.nodes.noNodes': '暂无关联节点',
  'cdn.line.nodes.emptyAvailable': '暂无可选节点',
  'cdn.common.createdAt': '创建时间',
  'cdn.common.updatedAt': '更新时间',

  // 节点管理
  'cdn.node.updateStatus.title': '更新节点状态',
  'cdn.node.updateStatus.deviceCode': '设备编码',
  'cdn.node.updateStatus.hostname': '主机名',
  'cdn.node.updateStatus.required.status': '请选择状态',

  // 缓存规则表单补充
  'cdn.cache.rules.form.contentPlaceholder': '请输入匹配内容',
  'cdn.cache.rules.form.ttlPlaceholder': '时长',
  'cdn.cache.rules.form.enableRule': '启用规则',
  'cdn.cache.rules.form.enableRange': '开启 Range 回源',
  'cdn.cache.rules.form.enableRangeTooltip':
    '向源站请求资源时携带 Range 头，支持分片回源以节省带宽',
  'cdn.cache.rules.form.ruleType': '规则类型',

  // 域名表格表单
  'cdn.domain.table.form.domainPlaceholder': '如 example.com',
  'cdn.domain.table.form.required.domain': '请输入域名',
  'cdn.domain.table.form.invalidDomain': '请输入有效的域名格式',
  'cdn.domain.table.action.verify': '验证',

  // Header 表单补充
  'cdn.header.table.addHeader': '添加头部',
  'cdn.header.table.form.headerType': '头部类型',
  'cdn.header.table.form.headerName': '头部名称',
  'cdn.header.table.form.headerNamePlaceholder': '如 X-Custom-Header',
  'cdn.header.table.form.value': '头部值',
  'cdn.header.table.form.valuePlaceholder': '输入头部值',
  'cdn.header.table.form.matchRegex': '匹配正则',
  'cdn.header.table.form.matchRegexPlaceholder': '正则表达式，如 ^(.*)$',
  'cdn.header.table.form.replacement': '替换内容',
  'cdn.header.table.form.replacementPlaceholder': '替换内容，如 $1-suffix',

  // 人机验证规则表单
  'cdn.human.rules.modal.title': '添加人机验证规则',
  'cdn.human.rules.form.required.name': '请输入规则名称',
  'cdn.human.rules.form.matchMode': '匹配方式',
  'cdn.human.rules.form.required.matchMode': '请选择匹配方式',
  'cdn.human.rules.form.required.operator': '请选择操作符',
  'cdn.human.rules.form.matchContentTip': '多个值使用 | 分隔',
  'cdn.human.rules.form.matchContentTipHeader':
    '格式：Header名:匹配值，如 X-Custom-Header:value',
  'cdn.human.rules.form.contentPlaceholderHeader': '如 X-Custom-Header:value',
  'cdn.human.rules.form.required.content': '请输入匹配内容',
  'cdn.human.rules.form.required.policy': '请选择验证方式',
  'cdn.human.rules.form.required.expiry': '请输入有效期',

  // 回源服务器详细表单
  'cdn.upstream.servers.add': '添加服务器',
  'cdn.upstream.servers.modal.addTitle': '添加上游服务器',
  'cdn.upstream.servers.modal.editTitle': '编辑上游服务器',
  'cdn.upstream.servers.form.address': '服务器地址',
  'cdn.upstream.servers.form.addressPlaceholder':
    '如 192.168.1.1 或 example.com',
  'cdn.upstream.servers.form.required.address': '请输入服务器地址',
  'cdn.upstream.servers.form.required.port': '请输入端口号',
  'cdn.upstream.servers.column.hostname': '主机名',
  'cdn.upstream.servers.form.hostnamePlaceholder': '请求头 Host 字段值（可选）',
  'cdn.upstream.servers.form.hostnameTooltip':
    '用于设置请求的 Host 头，与 TLS SNI 名称（tls_server_name）不同',
  'cdn.upstream.servers.form.remarkPlaceholder': '可选备注信息',
  'cdn.upstream.servers.tlsConfig': 'TLS 配置',
  'cdn.upstream.servers.enableHttps': '启用 HTTPS',
  'cdn.upstream.servers.httpsH2cConflict': '当前与 H2C 冲突，已禁用',
  'cdn.upstream.servers.http3AutoHttps': 'HTTP/3 已开启，HTTPS 已自动启用',
  'cdn.upstream.servers.useHttps': '使用 HTTPS 连接上游服务器',
  'cdn.upstream.servers.disableHttpsWarning':
    '关闭 HTTPS 后，TLS 相关配置将被忽略',
  'cdn.upstream.servers.protocolConfig': '协议配置',
  'cdn.upstream.servers.advancedConfig': '高级配置（超时设置）',
  'cdn.upstream.servers.storageAdvancedConfig': '高级配置（超时设置）',
  'cdn.upstream.servers.clientCert': '客户端公钥证书',
  'cdn.upstream.servers.clientCertDesc':
    '以下公私钥用于双向 TLS（mTLS）场景：当上游服务器要求验证客户端身份时填写。普通 HTTPS 回源无需填写，留空即可。公钥与私钥必须同时提供或同时留空。',
  'cdn.upstream.servers.clientCertPlaceholder':
    '可选，双向 TLS 时填写。粘贴公钥证书内容（PEM 格式，以 -----BEGIN CERTIFICATE----- 开头）',
  'cdn.upstream.servers.clientCertTooltip':
    '双向 TLS（mTLS）客户端公钥证书，普通 HTTPS 回源无需填写',
  'cdn.upstream.servers.clientKey': '客户端私钥',
  'cdn.upstream.servers.clientKeyPlaceholder':
    '可选，双向 TLS 时填写。粘贴私钥内容（PEM 格式，以 -----BEGIN ... KEY----- 开头）',
  'cdn.upstream.servers.clientKeyTooltip':
    '双向 TLS（mTLS）客户端私钥，普通 HTTPS 回源无需填写',
  'cdn.upstream.servers.certPairError.missingKey':
    '公钥已填写，私钥必须同时提供',
  'cdn.upstream.servers.certPairError.missingCert':
    '私钥已填写，公钥必须同时提供',
  'cdn.upstream.servers.skipTls': '跳过 TLS 验证',
  'cdn.upstream.servers.skipTlsTooltip':
    '不验证上游服务器证书（不推荐在生产环境使用）',
  'cdn.upstream.servers.caCert': 'CA 证书',
  'cdn.upstream.servers.caCertPlaceholder':
    '粘贴 CA 证书内容（可选，用于验证上游服务器证书）',
  'cdn.upstream.servers.connectTimeout': '连接超时',
  'cdn.upstream.servers.connectTimeoutTooltip':
    '连接上游服务器的超时时间（毫秒），默认 3000ms（3秒）',
  'cdn.upstream.servers.responseTimeout': '响应头超时',
  'cdn.upstream.servers.responseTimeoutTooltip':
    '等待响应头的超时时间（毫秒），默认 30000ms（30秒）',
  'cdn.upstream.servers.maxConn': '每主机最大连接数',
  'cdn.upstream.servers.maxConnTooltip':
    '对上游服务器的最大并发连接数，0 表示不限制',
  'cdn.upstream.servers.maxConnPlaceholder': '0（不限制）',

  // URL 访问控制规则
  'cdn.urlAccess.rules.modal.title': '添加 URL 访问控制规则',
  'cdn.urlAccess.rules.form.contentPlaceholder': '输入 URL 匹配内容',
  'cdn.urlAccess.rules.form.redirectPlaceholder':
    '如 https://example.com/new-path',

  // URL 重写规则补充
  'cdn.urlRewrite.rules.form.replacementPlaceholder': '如 /new/$1',

  // 地域规则表单
  'cdn.geo.rules.form.regionPlaceholder': '选择或输入地区代码（如 CN、US）',

  // 语言规则表单
  'cdn.language.rules.form.langList': '语言列表',
  'cdn.language.rules.form.langListPlaceholder':
    '多个语言用逗号分隔，如 zh-CN, en-US',
  'cdn.language.rules.form.redirectPlaceholder': '如 https://example.com/',

  // 站点创建补充
  'cdn.site.create.required.region': '请选择区域',
  'cdn.site.create.label.subscriptionType': '订阅类型',
  'cdn.site.subscriptionType.basic': '基础版',
  'cdn.site.subscriptionType.pro': '专业版',
  'cdn.site.subscriptionType.enterprise': '企业版',
  'cdn.common.tags': '标签',
  'cdn.site.create.tagsPlaceholder': '输入标签后按回车添加',
  'cdn.common.notSet': '未设置',
  'cdn.common.operator': '操作符',
  'cdn.ua.rules.form.allow': '允许访问',
  'cdn.cache.rules.form.queryWhitelist': 'Query 参数白名单',
  'cdn.cache.rules.form.whitelistParams': '白名单参数',
  'cdn.cache.rules.form.whitelistParamsTip':
    '仅缓存指定 Query 参数的组合，多个参数名用英文逗号分隔，如 page,size,sort',
  'cdn.cache.rules.form.required.whitelistParams': '请输入白名单参数',
  'cdn.cache.rules.form.whitelistParamsPlaceholder':
    '多个参数用逗号分隔，如 page,size',
  'cdn.cache.rules.form.invalidParamNames':
    '参数名只能包含字母、数字、下划线、连字符，不合法',
  'cdn.upstream.servers.caCertTooltip': '可选，用于验证上游服务器证书',
  'cdn.upstream.servers.skipTlsCaWarning': '跳过 TLS 验证时，CA 证书将被忽略',
  'cdn.upstream.servers.tlsSni': 'TLS SNI 名称',
  'cdn.upstream.servers.tlsSniPlaceholder':
    '用于 TLS 握手的服务器名称（最长 255 字符）',
  'cdn.upstream.servers.tlsSniTooltip': '可选，用于指定 TLS SNI 服务器名称',
  'cdn.upstream.servers.h2c': 'H2C（明文 HTTP/2）',
  'cdn.upstream.servers.h2cConflict':
    '当前与 HTTPS/HTTP/3/强制HTTP/2 冲突，已禁用',
  'cdn.upstream.servers.h2cDescription':
    '启用明文 HTTP/2 回源，与 HTTPS 和 HTTP/3 互斥',
  'cdn.upstream.servers.http3Description':
    'HTTP/3 基于 QUIC 协议，强制要求 TLS，开启后将自动启用 HTTPS 并与 H2C 互斥',
  'cdn.upstream.servers.http3Enabled': 'HTTP/3（QUIC）已启用',
  'cdn.upstream.servers.http3EnabledDesc':
    'QUIC 协议强制要求 TLS，已自动启用 HTTPS。TLS 证书字段（客户端证书、CA 证书）仍为可选，与普通 HTTPS 回源一致，无需额外填写。',
  'cdn.upstream.servers.forceHttp2': '强制 HTTP/2',
  'cdn.upstream.servers.forceHttp2Tip': '即使上游不支持 HTTP/2，也尝试升级',
  'cdn.upstream.servers.h2cHttpsConflict': 'H2C 与 HTTPS 不能同时启用',
  'cdn.upstream.servers.h2cHttp3Conflict': 'H2C 与 HTTP/3 不能同时启用',
  'cdn.upstream.servers.weightRange': '范围',
  'cdn.upstream.servers.weightDefault': '默认',
  'cdn.upstream.servers.origin_type': '回源类型',
  'cdn.upstream.servers.origin_type.http': 'HTTP/HTTPS 回源',
  'cdn.upstream.servers.origin_type.s3': 'S3 兼容存储',
  'cdn.upstream.servers.origin_type.oss': '阿里云 OSS',
  'cdn.upstream.servers.origin_type.cos': '腾讯云 COS',
  'cdn.upstream.servers.storage_bucket': 'Bucket 名称',
  'cdn.upstream.servers.storage_region': '存储区域',
  'cdn.upstream.servers.storage_endpoint': '自定义 Endpoint',
  'cdn.upstream.servers.storage_endpoint.tooltip.s3':
    '留空使用默认端点。填写可指向 S3 兼容存储（如 MinIO、Cloudflare R2、Ceph 等）',
  'cdn.upstream.servers.storage_endpoint.tooltip.oss':
    '填写阿里云 OSS 的 Endpoint，如 oss-cn-hangzhou.aliyuncs.com',
  'cdn.upstream.servers.storage_endpoint.tooltip.cos':
    '填写腾讯云 COS 的 Endpoint，如 cos.ap-guangzhou.myqcloud.com',
  'cdn.upstream.servers.storageAccessKey.title': '为什么需要 Access Key？',
  'cdn.upstream.servers.storageAccessKey.reason':
    '选择对象存储回源时，CDN 节点需要使用 Access Key 对请求进行签名认证，才能访问私有存储桶中的对象。',
  'cdn.upstream.servers.storageAccessKey.securityTitle': '安全建议：',
  'cdn.upstream.servers.storageAccessKey.tip1':
    '建议创建专有只读 Access Key，仅授予 GetObject 权限',
  'cdn.upstream.servers.storageAccessKey.tip2':
    '切勿使用拥有写入/删除权限的 Access Key',
  'cdn.upstream.servers.storageAccessKey.tip3': '定期轮换 Access Key',
  'cdn.upstream.servers.storageAccessKey.publicTitle': '公开存储替代方案：',
  'cdn.upstream.servers.storageAccessKey.publicDesc':
    ' 如果您的存储桶已设置为公开可读，可以选择「HTTP/HTTPS 回源」直接通过 URL 访问，无需配置 Access Key，避免密钥泄露风险。',
  'cdn.upstream.servers.access_key_id': 'Access Key ID',
  'cdn.upstream.servers.access_key_secret': 'Access Key Secret',

  // Dashboard - Time selector
  'cdn.oper.dashboard.period.today': '今天',
  'cdn.oper.dashboard.period.yesterday': '昨天',
  'cdn.oper.dashboard.period.7d': '近 7 天',
  'cdn.oper.dashboard.period.30d': '近 30 天',

  // Dashboard - Access data label
  'cdn.oper.dashboard.accessData': '访问数据',

  // Dashboard - Overview cards - dynamic titles
  'cdn.oper.dashboard.card.sites.today': '今日活跃站点',
  'cdn.oper.dashboard.card.sites.yesterday': '昨日活跃站点',
  'cdn.oper.dashboard.card.sites.7d': '近7天活跃站点',
  'cdn.oper.dashboard.card.sites.30d': '近30天活跃站点',
  'cdn.oper.dashboard.card.sites': '我的站点',
  'cdn.oper.dashboard.card.sites.suffix': '个',

  'cdn.oper.dashboard.card.traffic.today': '今日流量',
  'cdn.oper.dashboard.card.traffic.yesterday': '昨日流量',
  'cdn.oper.dashboard.card.traffic.7d': '近7天流量',
  'cdn.oper.dashboard.card.traffic.30d': '近30天流量',
  'cdn.oper.dashboard.card.traffic': '本月总流量',

  'cdn.oper.dashboard.card.requests.today': '今日请求',
  'cdn.oper.dashboard.card.requests.yesterday': '昨日请求',
  'cdn.oper.dashboard.card.requests.7d': '近7天请求',
  'cdn.oper.dashboard.card.requests.30d': '近30天请求',
  'cdn.oper.dashboard.card.requests': '本月总请求',
  'cdn.oper.dashboard.card.requests.suffix': '次',

  'cdn.oper.dashboard.card.cacheHitRate': '缓存命中率',

  // Dashboard - Chart titles
  'cdn.oper.dashboard.chart.traffic': '流量趋势',
  'cdn.oper.dashboard.chart.requests': '请求趋势',
  'cdn.oper.dashboard.chart.traffic.tooltip': '流量',
  'cdn.oper.dashboard.chart.requests.tooltip': '请求数',

  // Dashboard - Empty state
  'cdn.oper.dashboard.empty': '暂无数据',

  // CDN Ops Dashboard
  'cdn.ops.dashboard.card.totalNodes': '节点总数',
  'cdn.ops.dashboard.card.onlineNodes': '在线节点',
  'cdn.ops.dashboard.card.offlineNodes': '离线节点',
  'cdn.ops.dashboard.card.totalSites': '平台站点',
  'cdn.ops.dashboard.card.nodes.suffix': '台',
  'cdn.ops.dashboard.card.sites.suffix': '个',
  'cdn.ops.dashboard.health.title': '节点健康分布',
  'cdn.ops.dashboard.health.online': '在线',
  'cdn.ops.dashboard.health.offline': '离线',
  'cdn.ops.dashboard.abnormal.title': '异常节点速览',
  'cdn.ops.dashboard.abnormal.empty': '暂无异常节点',
  'cdn.ops.dashboard.requests.title': '请求统计',
  'cdn.ops.dashboard.requests.total': '累计请求',
  'cdn.ops.dashboard.requests.qps': '当前 QPS',
  'cdn.ops.dashboard.requests.peakQps': '峰值 QPS',
  'cdn.ops.dashboard.requests.qpsSuffix': '次/秒',
  'cdn.ops.dashboard.traffic.title': '流量统计',
  'cdn.ops.dashboard.traffic.total': '累计流量',
  'cdn.ops.dashboard.traffic.bandwidth': '当前带宽',
  'cdn.ops.dashboard.traffic.peakBandwidth': '峰值带宽',
  'cdn.ops.dashboard.nodes.title': '节点状态',
  'cdn.ops.dashboard.nodes.viewAll': '查看全部',
  'cdn.ops.dashboard.nodes.col.code': '设备编码',
  'cdn.ops.dashboard.nodes.col.region': '地区',
  'cdn.ops.dashboard.nodes.col.lines': '线路',
  'cdn.ops.dashboard.nodes.col.health': '健康状态',
  'cdn.ops.dashboard.nodes.col.status': '运行状态',
  'cdn.ops.dashboard.period.7d': '近 7 天',
  'cdn.ops.dashboard.period.30d': '近 30 天',

  // 节点配置管理
  'cdn.node.config.title': '节点配置',
  'cdn.node.config.empty': '暂无配置数据',
  'cdn.node.config.fetchFailed': '获取配置失败',
  'cdn.node.config.column.key': '配置项',
  'cdn.node.config.column.value': '配置值',
  'cdn.node.config.column.source': '来源',
  'cdn.node.config.source.default': '默认',
  'cdn.node.config.source.node': '自定义',
  'cdn.node.config.inheritedFromDefault': '继承自全局默认',
  'cdn.node.config.defaultValue': '默认值: {value}',
  'cdn.node.config.editModal.title': '编辑配置',
  'cdn.node.config.resetToDefault': '重置为默认值',
  'cdn.node.config.willReset': '将重置',
  'cdn.node.config.deleteWarning': '以下配置项将重置为默认值：{keys}',

  // 节点详情侧边栏导航
  'cdn.node.sideMenu.group.basic': '节点信息',
  'cdn.node.sideMenu.backToList': '返回节点列表',
  'cdn.node.tab.basic': '基本信息',
  'cdn.node.tab.config': '配置管理',
  'cdn.node.tab.stats': '流量统计',
  'cdn.node.tab.desc.basic':
    '查看节点基本信息，包括设备码、IP地址、区域、状态等。',
  'cdn.node.tab.desc.config':
    '管理节点的配置参数，支持继承全局默认配置或自定义节点专属配置。',
  'cdn.node.tab.desc.stats':
    '查看节点的流量统计信息，包括请求量、带宽、缓存命中率等。',

  // 缓存预设
  'cdn.cache.presets.button': '从预设添加',
  'cdn.cache.presets.title': '选择缓存预设',
  'cdn.cache.presets.description': '选择一个预设规则集，快速添加缓存规则',
  'cdn.cache.presets.applyMode': '应用方式',
  'cdn.cache.presets.append': '追加到现有规则',
  'cdn.cache.presets.replace': '替换所有现有规则',
  'cdn.cache.presets.replaceConfirm':
    '替换将删除所有现有缓存规则，确定继续吗？',
  'cdn.cache.presets.rulesCount': '{count} 条规则',
  'cdn.cache.presets.applySuccess': '预设规则应用成功',
  'cdn.cache.presets.applyFailed': '预设规则应用失败',
  'cdn.cache.presets.loading': '加载预设列表...',
};
